export default __webpack_public_path__ + "static/media/flag-cook-islands.aa7b443a.svg";